/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedRequestHold_item = {|
  +hasRequestedHoldForBuyer?: ?boolean;
  +displayInfo?: ?{|
    +ctas: ?{|
      +showHoldRequest: ?boolean;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRequestHold_item",
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "name": "hasRequestedHoldForBuyer",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp",
              "type": "PageDisplayEnum"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "CTADisplay",
              "name": "ctas",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "showHoldRequest",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item"
};

module.exports = fragment;
